export default {
	about_the_course: 'Sobre o curso',
	activity_plural: 'Atividades',
	activity: 'Atividade',
	attempts: 'Tentativas',
	block_general_test: "Teste geral 'Bloqueio'",
	block_test: "Teste 'Bloqueio'",
	blocked: 'Bloqueado',
	class_plural: 'Aulas',
	class: 'Aula',
	classes: 'Aulas',
	comment: 'Comentário',
	congratulations: 'Parabéns!',
	continue: 'Em progresso',
	conventional_test: "Teste 'Convencional'",
	discussions_about_this_course: 'Discussões sobre esse curso',
	doubts: 'Dúvidas?',
	end_quiz: 'Finalizar Quiz',
	enroll: 'Matricular-se',
	enrolled: 'Matriculados',
	enrollement_type: 'Tipo de matrícula',
	evaluated_quiz: 'Quiz com Avaliação',
	finish_test: 'Finalizar',
	flash: 'Flash',
	html: 'HTML',
	if_you_are_not_approved_within_the_available_attempts_you_will_have_your_progress_restarted:
		'Se você não for aprovado dentro das tentativas disponíveis, você terá seu progresso reiniciado.',
	if_you_fail_the_available_attempts_you_will_be_blocked_in_this_training:
		'Se você não for aprovado dentro das tentativas disponíveis você será bloqueado nesse treinamento.',
	if_you_pass_you_can_use_the_remaining_attempts_to_try_to_improve_your_grade:
		'Se for aprovado pode usar as tentativas restantes para tentar melhorar sua nota.',
	improved: 'Melhorado',
	in_this_course: 'nesse curso',
	keep_trying: 'Continue tentando.',
	loading_courses: 'Carregando cursos',
	mandatory: 'Obrigatórios',
	maximum_attempts: 'Máximo de Tentativas',
	minimum_to_pass: 'Mínimo para Passar',
	next_question: 'Próxima',
	previous_question: 'Anterior',
	no_courses_are_available_at_the_moment: 'Não há cursos disponíveis no momento',
	no_courses_are_available_with_the_selected_filter:
		'Não há cursos disponíveis para o filtro selecionado',
	not_started: 'Não Iniciado',
	number_of_questions: 'Número de perguntas',
	of_attempts: '{qty_attempted} de {maximum_attempts} tentativas',
	of_questions: '{minimum_score} de {qty_questions} questões',
	once_you_start_the_test_you_should_not_change_activity_leave_or_refresh_the_page:
		'Quando iniciar o teste você não deve mudar de atividade, voltar, sair ou atualizar a página.',
	one_attempt: 'Uma tentativa',
	overview: 'Visão Geral',
	powerpoint: 'PowerPoint',
	presentation: 'Apresentação',
	previous_results: 'Resultados Anteriores',
	question_plural: 'Perguntas',
	question: 'Pergunta',
	reproved: 'Reprovado',
	restart_general_test: "Teste geral 'Reset'",
	restart_test: "Teste 'Reset'",
	restart_training: 'Reiniciar treinamento',
	restarted: 'Reiniciado',
	scorm: 'Atividade',
	see_previous_results: 'Ver resultados anteriores',
	see_results: 'Ver resultados',
	see_answers:  'Visualizar respostas',
	slideshare: 'Slideshare',
	start_quiz: 'Iniciar Quiz',
	start_test: 'Iniciar Teste',
	start: 'Iniciar',
	support_material_preview: 'Pré-visualização do Material de Apoio',
	support_materials: 'Materiais de Apoio',
	test_performance: 'Aproveitamento no teste',
	thank_you_for_taking_the_quiz: 'Obrigado por participar do quiz',
	that_was_close: 'Foi por pouco!',
	the_result_of_this_quiz_will_not_influence_the_final_result_of_your_training:
		'O resultado desse quiz não irá influenciar no resultado final do seu treinamento.',
	time_left: 'Tempo restante',
	time_to_finish: 'Tempo para Finalizar',
	unenroll: 'Desmatricular-se',
	unevaluated_quiz: 'Quiz sem Avaliação',
	unlimited: 'Ilimitadas',
	until_approval: 'Até aprovação',
	video: 'Vídeo',
	view_history: 'ver histórico',
	when_starting_the_quiz_you_should_not_change_your_activity_leave_or_update_the_page:
		'Quando iniciar o quiz você não deve mudar de atividade, sair ou atualizar a página.',
	you_are_allowed_to_take_this_test_how_many_times_you_like_until_you_reach_the_minimum_score_to_pass:
		'Você pode responder esse teste quantas vezes desejar até que atinja a pontuação mínima para ser aprovado.',
	you_can_take_this_quiz_as_many_times_as_needed_and_you_will_need_to_get_out_of_questions_to_pass:
		'Você pode responder esse quiz quantas vezes forem necessárias e precisará acertar {minimum_score} de {qty_questions} questões para ser aprovado.',
	you_can_take_this_quiz_only_once_to_answer_as_many_questions_as_possible:
		'Você pode responder esse quiz apenas uma vez para acertar o maior número de questões possíveis.',
	you_can_take_this_test_only_once_with_a_timeout_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test:
		'Você pode responder esse teste apenas uma vez com o tempo limite de {time_to_answer} para atingir a pontuação mínima para ser aprovado. Você precisará acertar {minimum_score} de {qty_questions} questões para ser aprovado nesse teste.',
	you_can_take_this_test_up_to_times_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test:
		'Você pode responder esse teste até {maximum_attempts} vezes para atingir a pontuação mínima para ser aprovado. Você precisará acertar {minimum_score} de {qty_questions} questões para ser aprovado nesse teste.',
	you_got_out_of_questions_right_success_rate_and_you_showed_that_you_understand_a_lot_keep_it_up_and_show_that_you_are_the_one_who_dominates_this_subject:
		'Você acertou {score} de {questions} questões ({percent}% de aproveitamento) e mostrou que entende muito! Continue assim e mostre que quem mais domina esse assunto é você!',
	you_got_out_of_questions_successful_and_you_didnt_reach_the_minimum_score_to_pass:
		'Você acertou {score} de {questions} ({percent}% de aproveitamento) e não atingiu a nota mínima para aprovação ({minimum_score}% de aproveitamento).',
	you_got_out_of_success: 'Você acertou {score} de {questions} ({percent}% de aproveitamento).',
	you_have_already_answered_this_test_times_and_have_attempt_left:
		'Você já respondeu esse teste {qty_attempted} vezes e possui {attempts_left} tentativas restantes.',
	you_have_been_blocked_in_this_course_and_will_not_receive_a_certificate:
		'Você foi bloqueado neste curso e não irá receber um certificado',
	you_have_been_blocked_in_this_training_and_will_not_receive_a_certificate_you_can_still_finish_the_other_available_activities:
		'Você foi bloqueado neste treinamento e não receberá um certificado. Você ainda pode finalizar as demais atividades disponíveis.',
	you_have_been_blocked: 'Você foi bloqueado',
	you_have_only_one_attempt_to_pass_and_will_be_blocked_from_this_training_if_you_fail:
		'Você possui apenas uma tentativa para ser aprovado e será bloqueado nesse treinamento caso falhe.',
	you_have_only_one_attempt_to_pass_and_will_have_your_progress_restarted_in_this_training_if_you_fail:
		'Você possui apenas uma tentativa para ser aprovado e terá seu progresso reiniciado nesse treinamento caso falhe.',
	you_need_to_enroll_before_starting_this_content:
		'Você precisa se matricular antes de iniciar esse conteúdo',
	you_need_to_enroll_before_starting_this_course:
		'Você precisa matricular-se antes de começar este curso',
	you_need_to_finish_another_course_before_starting_this:
		'Você precisa finalizar outro curso antes de inicializar esse',
	you_need_to_get_of_questions_right_to_be_approved:
		'Você precisará acertar {minimum_score} de {qty_questions} questões para ser aprovado nesse teste.',
	your_progress_has_been_restarted_and_you_will_need_to_redo_all_activities_in_this_training_to_receive_the_certificate:
		'Seu progresso foi reiniciado e você precisará refazer todas as atividades desse treinamento para receber o certificado.',
	your_progress_has_been_restarted: 'Seu progresso foi reiniciado',
	you_have_been_reproved_and_reached_the_maximum_attempts_restart_training:
		'Você foi reprovado e atingiu a quantidade máxima de tentativas sem aprovação. Seu treinamento foi reiniciado, refaça todas as atividades anteriores para tentar novamente.',
	your_result: 'Seu Resultado',
	your_status: 'Seu Status',
	training_in_progress: 'Curso sendo desenvolvido pelo gestor',
	video_issue_ios_message: 'Está com dificuldade para assistir ao vídeo? Não se preocupe! Toque no botão abaixo para abrir no navegador do seu celular.',
	watch_in_browser: 'Assistir no navegador',
}
